// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const stopUserSession = async ({
    test,
    sessionId,
}: {
    test: boolean,
    sessionId: string,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleStopUserSession = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        boolean
    >(
        functions,
        'stopUserSession',
    );
    return handleStopUserSession({
        test,
        sessionId,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default stopUserSession;
